import { useCallback, useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { fetchInventories } from 'application/usecases/fetchInventories'
import { Inventory } from 'domain/entities/Inventory'
import { GraphQLInventoryRepository } from 'infrastructure/graphql/InventoryRepositoryImpl'

export const useFetchInventories = () => {
  const { getIdTokenClaims } = useAuth0()
  const [data, setData] = useState<Inventory[]>([])
  const [loading, setLoading] = useState(true)

  const refetch = useCallback(async () => {
    setLoading(true)
    const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
    const repo = new GraphQLInventoryRepository(getToken)
    const list = await fetchInventories(repo)()
    setData(list)
    setLoading(false)
  }, [getIdTokenClaims])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { data, loading, refetch }
}
